import { createStore } from "@stencil/store";
import { FlyoutState } from "@apis/model/core";
import { RequestHeaderService } from "globals/helpers";
import {
  impersonateSearchApi,
  impersonateUserResetApi,
  impersonateUserSelectApi,
} from "../frontend-kit/organisms/f-header/f-impersonate-flyout/f-impersonate-config";
import { ImpersonateUser } from "../frontend-kit/organisms/f-header/f-impersonate-flyout/f-impersonate-model";

interface ImpersonateStore {
  customers: ImpersonateUser[];
  flyoutState: FlyoutState;
}

function handleErrors() {
  set("flyoutState", "ERROR");
}

function stopLoading() {
  set("flyoutState", "LOADED");
}

const { state, set } = createStore({
  customers: [],
  flyoutState: "INIT",
} as ImpersonateStore);

export function getCustomers(): Promise<ImpersonateUser[]> {
  return fetchUserData()
    .then((customerList) => {
      stopLoading();
      return customerList;
    })
    .catch(() => {
      handleErrors();
      return [];
    });
}

function fetchUserData(): Promise<ImpersonateUser[]> {
  return fetch(impersonateSearchApi, {
    method: "POST",
    body: JSON.stringify({
      searchData: {
        text: "",
      },
    }),
    ...RequestHeaderService.getHeadersWithJwt(),
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error();
    }

    const users: ImpersonateUser[] = await response.json();
    set("customers", users);
    return users;
  });
}

export function actAsMyself(): Promise<void> {
  return fetch(impersonateUserResetApi, {
    method: "POST",
    ...RequestHeaderService.getHeadersWithJwt(),
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error();
    }

    const responseBody = await response.json();
    window.location.href = responseBody.url;
  });
}

export function selectCustomer(customerId: string): Promise<void> {
  return selectCustomerApi(customerId)
    .then(() => {
      stopLoading();
    })
    .catch(() => {
      handleErrors();
    });
}

function selectCustomerApi(customerId: string): Promise<void> {
  return fetch(impersonateUserSelectApi, {
    method: "POST",
    body: JSON.stringify({ salesAreaDependentCustomerUid: customerId }),
    ...RequestHeaderService.getHeadersWithJwt(),
  }).then(async (response) => {
    if (!response.ok) {
      throw new Error();
    }

    const responseBody = await response.json();
    window.location.href = responseBody.url;
  });
}

export default state;
